module.exports = __webpack_public_path__ + "img/箭头-下.ff7ad060.png";